import { defineComponent as _defineComponent } from 'vue'
import { computed, type CSSProperties } from 'vue';
import GoogleAuthIcon from '@/assets/images/svg/auth-google.svg?component';
import MicrosoftAuthIcon from '@/assets/images/svg/auth-microsoft.svg?component';
import EmailAuthIcon from '@/assets/images/svg/auth-email.svg?component';

type ButtonVariant = 'primary' | 'secondary';
type IconType = 'google' | 'email' | 'microsoft';
type ButtonType = 'button' | 'submit' | 'reset';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthActionButton',
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    text: { default: 'Sign in with Google' },
    loadingText: { default: 'Connecting to Google...' },
    fullWidth: { type: Boolean, default: false },
    variant: { default: 'secondary' },
    iconType: { default: 'google' },
    showIcon: { type: Boolean, default: true },
    buttonType: { default: 'button' }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { loading: boolean, disabled: boolean, text: string, loadingText: string, fullWidth: boolean, variant: ButtonVariant, iconType: IconType, showIcon: boolean, buttonType: ButtonType };




const isPrimary = computed(() => props.variant === 'primary');

const disabledStyle = computed<CSSProperties | undefined>(() => {
  if (!props.disabled) return undefined;

  if (isPrimary.value) {
    return {
      backgroundColor: '#b2b9c4',
      borderColor: '#b2b9c4',
      color: '#ffffff',
      opacity: '0.6',
      cursor: 'not-allowed',
    };
  }

  return {
    backgroundColor: '#f5f5f5',
    borderColor: '#d6d6d6',
    color: '#9c9c9c',
    opacity: '0.6',
    cursor: 'not-allowed',
  };
});

const spinnerBorderClass = computed(() =>
  isPrimary.value ? 'tw:border-t-white' : 'tw:border-t-[#4285f4]'
);

return { __sfc: true,props, emit, isPrimary, disabledStyle, spinnerBorderClass, GoogleAuthIcon, MicrosoftAuthIcon, EmailAuthIcon }
}

})